import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ProductDetail({ product, returnPath }) {
  // returnPath prop 받기
  const navigate = useNavigate();

  if (!product) {
    return (
      <div className="text-center py-20">제품 정보를 찾을 수 없습니다.</div>
    );
  }

  return (
    <div className="w-[70%] mx-auto py-12 flex flex-col gap-12">
      {/* 제품 정보 컨테이너: 모바일에서는 세로 배치, 데스크톱에서는 가로 배치 */}
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
        {/* 좌측: 제품 이미지 - 모바일에서는 전체 너비, 데스크톱에서는 절반 너비 */}
        <div className="w-full lg:w-1/2 flex justify-start items-start">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-auto object-contain rounded-md shadow"
          />
        </div>

        {/* 우측: 제품 정보 - 모바일에서는 전체 너비, 데스크톱에서는 절반 너비 */}
        <div className="w-full lg:w-1/2 flex flex-col space-y-6">
          <h1 className="text-3xl font-bold">{product.name}</h1>
          <p className="text-lg font-medium">용량: {product.amount}</p>
          <p className="text-xl font-semibold text-gray-800">
            가격: {product.price}
          </p>
          {product.highlight && (
            <p className="text-md font-semibold whitespace-pre-line text-gray-400">
              {product.highlight}
            </p>
          )}
          {product.description && (
            <p className="text-sm font-normal whitespace-pre-line leading-relaxed">
              {product.description}
            </p>
          )}
          {product.ingredient && (
            <div>
              <h2 className="font-semibold whitespace-pre-line mb-1">성분</h2>
              <p className="whitespace-pre-line text-sm">
                {product.ingredient}
              </p>
            </div>
          )}
          {product.dosage && (
            <div>
              <h2 className="font-semibold mb-1">복용법</h2>
              <p className="whitespace-pre-line text-sm">{product.dosage}</p>
            </div>
          )}
          {product.warnings && (
            <div>
              <h2 className="font-semibold mb-1">주의사항</h2>
              <p className="whitespace-pre-line text-sm">{product.warnings}</p>
            </div>
          )}
        </div>
      </div>
      {/* 목록으로 돌아가기 버튼 */}
      <div className="flex justify-center mt-8">
        {' '}
        {/* 중앙 정렬 및 상단 마진 추가 */}
        <button
          onClick={() => navigate(returnPath)}
          className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-md hover:bg-gray-300 transition-colors shadow-md"
        >
          {returnPath === '/human'
            ? '인체용 제품 목록으로 돌아가기'
            : '동물용 제품 목록으로 돌아가기'}
        </button>
      </div>
    </div>
  );
}
